import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ChevronRight, Home as HomeIcon } from 'lucide-react';
import ArticleCard from '../components/ArticleCard';
import Sidebar from '../components/Sidebar';
import AdBox from '../components/AdBox';
import { fetchArticles, fetchWeather, fetchTrending } from '../services/newsService';
import { AD_SLOTS, CATEGORIES } from '../mock/mock';

const DESCRIPTIONS = {
  headlines: 'Breaking news and the biggest stories from across Michigan \u2014 updated throughout the day.',
  politics: 'State, local and civic coverage from Lansing to your city hall across Michigan.',
  sport: 'The Lions, Pistons, Red Wings, Wolverines, Spartans and more \u2014 all your Michigan sports.',
  financials: 'Markets, manufacturing, jobs and the Michigan economy \u2014 what it means for you.',
  fashion: 'Style, designers, boutiques and trends shaping fashion across Michigan.',
};

export default function Category() {
  const { slug } = useParams();
  const [articles, setArticles] = useState([]);
  const [weather, setWeather] = useState([]);
  const [trending, setTrending] = useState([]);
  const [loading, setLoading] = useState(true);

  const label = CATEGORIES.find((c) => c.slug === slug)?.label || 'News';

  useEffect(() => {
    let m = true;
    setLoading(true);
    Promise.all([fetchArticles(slug), fetchWeather(), fetchTrending()]).then(([a, w, t]) => {
      if (!m) return;
      setArticles(a); setWeather(w); setTrending(t); setLoading(false);
    });
    return () => { m = false; };
  }, [slug]);

  const lead = articles[0];
  const rest = articles.slice(1);

  return (
    <div className="max-w-[1320px] mx-auto px-4 py-6">
      {/* Breadcrumb */}
      <nav className="flex items-center gap-1.5 text-[13px] text-[#5b6b63] mb-4">
        <Link to="/" className="inline-flex items-center gap-1 hover:text-[#157347]"><HomeIcon className="w-3.5 h-3.5" />Home</Link>
        <ChevronRight className="w-3.5 h-3.5" />
        <span className="text-[#157347] font-semibold">{label}</span>
      </nav>

      {/* Category header */}
      <div className="border-b-2 border-[#157347] pb-4 mb-6">
        <h1 className="font-display font-extrabold text-4xl text-[#0b3d26]">{label}</h1>
        <p className="text-[#5b6b63] mt-2 max-w-2xl">{DESCRIPTIONS[slug] || 'Michigan news and updates.'}</p>
      </div>

      {loading ? (
        <div className="py-16 text-center text-[#5b6b63]">
          <div className="inline-block w-8 h-8 border-2 border-[#157347] border-t-transparent rounded-full animate-spin" />
        </div>
      ) : articles.length === 0 ? (
        <div className="py-16 text-center text-[#5b6b63]">No stories available in this section yet. Please check back soon.</div>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            {lead && (
              <div className="mb-6"><ArticleCard article={lead} variant="hero" /></div>
            )}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {rest.map((a) => (<ArticleCard key={a.id} article={a} variant="feature" />))}
            </div>
            <div className="mt-8">
              <AdBox size={AD_SLOTS.inline.size} label={AD_SLOTS.inline.label} note={AD_SLOTS.inline.note} height={110} />
            </div>
          </div>
          <div className="lg:col-span-1">
            <Sidebar weather={weather} trending={trending} ads={AD_SLOTS.sidebar} />
          </div>
        </div>
      )}
    </div>
  );
}
